// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Forms_wrapper__WXz-Q","actionsDropdownWrapper":"Forms_actionsDropdownWrapper__14otY"};